import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useSettingEnableUnsubscribeByMarketingType } from "@faire/retailer-visitor-shared/settings/useSettingEnableUnsubscribeByMarketingType";
import { useSettingNewEmailUnsubscribePreferencePage } from "@faire/retailer-visitor-shared/settings/useSettingNewEmailUnsubscribePreferencePage";
import { StickySaveProfileButton } from "@faire/retailer-visitor-shared/views/settings/components/StickySaveProfileButton";
import { EmailPreferencesContentWrapper } from "@faire/retailer-visitor-shared/views/settings/email-preferences/components/EmailPreferencesForm";
import { useEmailPreferencesQuery } from "@faire/retailer-visitor-shared/views/settings/email-preferences/hooks/useEmailPreferencesQuery";
import { logError } from "@faire/web--source/common/logging";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Toggle } from "@faire/web--source/slate/Toggle";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { useMutation as useMutatePreferences } from "@faire/web-api--source/api/email/preferences/post-hooks";
import { IGetEmailPreferencesResponse } from "@faire/web-api--source/com/faire/email/preferences/IGetEmailPreferencesResponse";
import { IUpdateEmailPreferencesRequest } from "@faire/web-api--source/com/faire/email/preferences/IUpdateEmailPreferencesRequest";
import { trackRetailerSettingsPageOptOutOfAllFaireMarketingEmailsClick } from "@faire/web-api--source/events/retailerSettingsPage/click/optOutOfAllFaireMarketingEmails";
import { IUnsubscribedMarketingTypeGroup } from "@faire/web-api--source/faire/emailsender/requests/IUnsubscribedMarketingTypeGroup";
import { UnsubscribedMarketingType } from "@faire/web-api--source/indigofair/data/UnsubscribedMarketingType";
import * as React from "react";
import styled from "styled-components";
export var FaireSentEmailPreferences = function() {
    var settingNewEmailUnsubscribePreferencePage = useSettingNewEmailUnsubscribePreferencePage();
    var settingEnableUnsubscribeByMarketingType = useSettingEnableUnsubscribeByMarketingType();
    var _React_useState = _sliced_to_array(React.useState({}), 2), updatedIsUnsubscribed = _React_useState[0], setUpdatedIsUnsubscribed = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(), 2), updatedIsUnsubscribedFromAll = _React_useState1[0], setUpdatedIsUnsubscribedFromAll = _React_useState1[1];
    var _useEmailPreferencesQuery = useEmailPreferencesQuery(), emailPreferencesResponse = _useEmailPreferencesQuery.emailPreferencesResponse, updateEmailPreferencesQuery = _useEmailPreferencesQuery.updateEmailPreferencesQuery;
    var _useMutatePreferences = useMutatePreferences(), mutatePreferencesAsync = _useMutatePreferences.mutateAsync, isMutatePreferencesLoading = _useMutatePreferences.isPending;
    var initialIsUnsubscribedFromAll = (emailPreferencesResponse === null || emailPreferencesResponse === void 0 ? void 0 : emailPreferencesResponse.unsubscribed_marketing_types.includes(UnsubscribedMarketingType.FAIRE_SENT)) || !!(emailPreferencesResponse === null || emailPreferencesResponse === void 0 ? void 0 : emailPreferencesResponse.is_unsubscribed_from_all);
    var isUnsubscribedFromAll = updatedIsUnsubscribedFromAll !== null && updatedIsUnsubscribedFromAll !== void 0 ? updatedIsUnsubscribedFromAll : initialIsUnsubscribedFromAll;
    var hasChanged = Object.keys(updatedIsUnsubscribed).length > 0 || isUnsubscribedFromAll !== initialIsUnsubscribedFromAll;
    var handleToggleIsUnsubscribed = function(emailSubgroup, isUnsubscribed) {
        var newIsUnsubscribedValue = !isUnsubscribed;
        if (newIsUnsubscribedValue === false) {
            setUpdatedIsUnsubscribedFromAll(false);
        }
        setUpdatedIsUnsubscribed(function(prevState) {
            var updatedState = _object_spread({}, prevState);
            if (emailSubgroup in updatedState) {
                delete updatedState[emailSubgroup];
            } else {
                updatedState[emailSubgroup] = newIsUnsubscribedValue;
            }
            return updatedState;
        });
    };
    var handleUnsubscribeFromAll = function() {
        setUpdatedIsUnsubscribed(function() {
            var updatedState = {};
            emailPreferencesResponse === null || emailPreferencesResponse === void 0 ? void 0 : emailPreferencesResponse.email_preference_groups.forEach(function(group) {
                group.subgroups.forEach(function(subgroup) {
                    if (subgroup.email_subgroup && !subgroup.is_unsubscribed) {
                        updatedState[subgroup.email_subgroup] = true;
                    }
                });
            });
            return updatedState;
        });
        setUpdatedIsUnsubscribedFromAll(true);
        trackRetailerSettingsPageOptOutOfAllFaireMarketingEmailsClick();
    };
    var submitSubscriptionUpdates = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var updatedGroups, updateRequest, response;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        updatedGroups = emailPreferencesResponse === null || emailPreferencesResponse === void 0 ? void 0 : emailPreferencesResponse.email_preference_groups.map(function(group) {
                            return _object_spread_props(_object_spread({}, group), {
                                subgroups: group.subgroups.map(function(subgroup) {
                                    if (subgroup.email_subgroup && subgroup.email_subgroup in updatedIsUnsubscribed) {
                                        return _object_spread_props(_object_spread({}, subgroup), {
                                            is_unsubscribed: updatedIsUnsubscribed[subgroup.email_subgroup]
                                        });
                                    }
                                    return subgroup;
                                })
                            });
                        });
                        updateRequest = IUpdateEmailPreferencesRequest.build({
                            email_preference_groups: updatedGroups
                        });
                        // when we offer brand-level email configurations, we should only opt out of Faire-sent
                        if (settingNewEmailUnsubscribePreferencePage) {
                            updateRequest.unsubscribed_marketing_type_groups = [
                                IUnsubscribedMarketingTypeGroup.build({
                                    unsubscribed_marketing_type: UnsubscribedMarketingType.FAIRE_SENT,
                                    is_unsubscribed: isUnsubscribedFromAll
                                })
                            ];
                        } else if (settingEnableUnsubscribeByMarketingType) {
                            // otherwise, this button unsubscribes from all emails (Faire-sent and brand-sent)
                            updateRequest.unsubscribed_marketing_type_groups = [
                                IUnsubscribedMarketingTypeGroup.build({
                                    unsubscribed_marketing_type: UnsubscribedMarketingType.FAIRE_SENT,
                                    is_unsubscribed: isUnsubscribedFromAll
                                }),
                                IUnsubscribedMarketingTypeGroup.build({
                                    unsubscribed_marketing_type: UnsubscribedMarketingType.BRAND_CRM_SENT,
                                    is_unsubscribed: isUnsubscribedFromAll
                                })
                            ];
                        } else {
                            updateRequest.unsubscribe_from_all = isUnsubscribedFromAll;
                        }
                        return [
                            4,
                            mutatePreferencesAsync([
                                updateRequest
                            ])
                        ];
                    case 1:
                        response = _state.sent();
                        updateEmailPreferencesQuery(IGetEmailPreferencesResponse.build(_object_spread_props(_object_spread({}, response), {
                            unsubscribed_marketing_types: response.unsubscribed_marketing_type_groups.filter(function(group) {
                                return group.is_unsubscribed;
                            }).map(function(group) {
                                return group.unsubscribed_marketing_type;
                            }).filter(isNotUndefined)
                        })));
                        setUpdatedIsUnsubscribed({});
                        return [
                            2
                        ];
                }
            });
        });
        return function submitSubscriptionUpdates() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(EmailPreferencesContentWrapper, {
                children: /*#__PURE__*/ _jsxs(EmailGroupsList, {
                    children: [
                        emailPreferencesResponse === null || emailPreferencesResponse === void 0 ? void 0 : emailPreferencesResponse.email_preference_groups.map(function(group) {
                            return /*#__PURE__*/ _jsx(EmailPreferencesGroup, {
                                emailPreferenceGroup: group,
                                isLoading: isMutatePreferencesLoading,
                                handleToggleIsUnsubscribed: handleToggleIsUnsubscribed,
                                updatedIsUnsubscribed: updatedIsUnsubscribed
                            }, group.title);
                        }),
                        /*#__PURE__*/ _jsx(LeftAlignedButton, {
                            disabled: isUnsubscribedFromAll || isMutatePreferencesLoading,
                            onClick: handleUnsubscribeFromAll,
                            variant: "tertiary",
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "FaEHOQ",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Opt out of all Faire marketing emails"
                                    }
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(StickySaveProfileButton, {
                onClickPromise: submitSubscriptionUpdates,
                disabled: !hasChanged,
                isVisible: hasChanged,
                "data-test-id": "save-button",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "jvo0vs",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Save"
                        }
                    ]
                })
            })
        ]
    });
};
var EmailPreferencesGroup = function(_param) {
    var emailPreferenceGroup = _param.emailPreferenceGroup, requiredSubgroupProps = _object_without_properties(_param, [
        "emailPreferenceGroup"
    ]);
    var title = emailPreferenceGroup.title, email_group = emailPreferenceGroup.email_group, subgroups = emailPreferenceGroup.subgroups;
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansMedium",
                children: title
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(GroupColumn, {
                children: subgroups.map(function(subgroup) {
                    return /*#__PURE__*/ _jsx(EmailPreferencesSubGroup, _object_spread({
                        emailPreferenceSubGroup: subgroup
                    }, requiredSubgroupProps), subgroup.title);
                })
            })
        ]
    }, email_group);
};
var EmailPreferencesSubGroup = function(param) {
    var emailPreferenceSubGroup = param.emailPreferenceSubGroup, updatedIsUnsubscribed = param.updatedIsUnsubscribed, handleToggleIsUnsubscribed = param.handleToggleIsUnsubscribed, isLoading = param.isLoading;
    var title = emailPreferenceSubGroup.title, email_subgroup = emailPreferenceSubGroup.email_subgroup, description = emailPreferenceSubGroup.description, is_unsubscribed = emailPreferenceSubGroup.is_unsubscribed;
    if (title === undefined || email_subgroup === undefined) {
        logError("all email subgroups must have a title and value");
        return null;
    }
    var _updatedIsUnsubscribed_email_subgroup;
    var isUnsubscribedFromSubgroup = (_updatedIsUnsubscribed_email_subgroup = updatedIsUnsubscribed[email_subgroup]) !== null && _updatedIsUnsubscribed_email_subgroup !== void 0 ? _updatedIsUnsubscribed_email_subgroup : is_unsubscribed;
    var toggleId = "toggle-".concat(email_subgroup);
    return /*#__PURE__*/ _jsxs(SubgroupRow, {
        justify: "space-between",
        children: [
            /*#__PURE__*/ _jsx(Column, {
                children: /*#__PURE__*/ _jsxs("label", {
                    htmlFor: toggleId,
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraphSansMedium",
                            children: title
                        }),
                        description ? /*#__PURE__*/ _jsx(Typography, {
                            children: description
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "1x"
            }),
            /*#__PURE__*/ _jsx(Toggle, {
                id: toggleId,
                hideText: true,
                disabled: isLoading,
                value: !isUnsubscribedFromSubgroup,
                onChange: function() {
                    handleToggleIsUnsubscribed(email_subgroup, isUnsubscribedFromSubgroup);
                }
            })
        ]
    }, email_subgroup);
};
var EmailGroupsList = styled.section.withConfig({
    componentId: "sc-8c7d941c-0"
})([
    "max-width:670px;"
]);
var GroupColumn = styled(Column).withConfig({
    componentId: "sc-8c7d941c-1"
})([
    "border:1px solid ",
    ";padding:8px 24px;margin-bottom:32px;"
], Core.border.muted);
var SubgroupRow = styled(Row).withConfig({
    componentId: "sc-8c7d941c-2"
})([
    "padding:16px 0;border-top:1px solid ",
    ";&:first-of-type{border-top:unset;}"
], Core.border.muted);
var LeftAlignedButton = styled(Button).withConfig({
    componentId: "sc-8c7d941c-3"
})([
    "text-align:left;"
]);
